import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiMail, FiLock, FiLogIn } from 'react-icons/fi';
import AuthShell from '../components/auth/AuthShell';
import { isLocalHubRuntime, getLocalHubHomePath } from '../utils/runtime';

function RestaurantLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password, 'restaurant');
    
    if (result.success) {
      navigate(isLocalHubRuntime() ? getLocalHubHomePath('restaurant_admin') : '/restaurant/dashboard');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <AuthShell
      title="ElyDine"
      subtitle="Restaurant Management Portal"
      quote="Great hospitality starts with a calm, organized service floor."
    >
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-white tracking-tight">Welcome Back</h2>
        <p className="text-sm text-gray-300 mt-2">Sign in to continue to your account</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        {error && (
          <div className="p-4 bg-gray-800 border-2 border-red-500 rounded-lg text-sm text-white">
            {error}
          </div>
        )}

        <div>
          <label className="block text-sm font-semibold text-white uppercase tracking-wide mb-2">
            Email Address
          </label>
          <div className="relative">
            <FiMail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-14 pl-10 pr-4 border-2 border-gray-700 rounded-lg bg-gray-800 text-white placeholder:text-gray-400 focus:outline-none focus:border-white focus:ring-0"
              placeholder="admin@restaurant.com"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-white uppercase tracking-wide mb-2">
            Password
          </label>
          <div className="relative">
            <FiLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full h-14 pl-10 pr-4 border-2 border-gray-700 rounded-lg bg-gray-800 text-white placeholder:text-gray-400 focus:outline-none focus:border-white focus:ring-0"
              placeholder="Enter your password"
              required
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full h-14 bg-white hover:bg-gray-100 text-gray-900 font-semibold text-base transition-all duration-200 rounded-lg shadow-lg hover:shadow-xl active:scale-[0.98] flex items-center justify-center gap-2 disabled:opacity-50"
        >
          {loading ? (
            'Signing in...'
          ) : (
            <>
              <FiLogIn /> Sign In
            </>
          )}
        </button>
      </form>

      <div className="mt-6 text-center text-sm text-gray-600">
        <p className="text-gray-300">Need access? Contact your administrator</p>
      </div>
    </AuthShell>
  );
}

export default RestaurantLogin;



